import React from 'react';
import { Home, Anchor } from 'lucide-react';

const Sluzby = () => {
  return (
    <section className="py-16 px-4 bg-gray-50 min-h-screen" data-testid="sluzby-section">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">Služby</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Ubytování */}
          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow">
            <div className="text-center mb-4">
              <Home className="w-12 h-12 mx-auto text-blue-600 mb-2" />
              <h3 className="text-xl font-bold text-gray-800">Ubytování</h3>
            </div>
            <div className="space-y-2 text-gray-700">
              <p className="text-sm">DO 10 LET <span className="font-bold">0,- Kč</span></p>
              <p className="text-sm">OD 10-18 LET + Student  <span className="font-bold">100,- Kč</span></p>
              <p className="text-sm font-bold">ZA NOC</p>
              <p className="text-sm">DOSPĚLÍ <span className="font-bold">150,- Kč ZA NOC</span></p>
              <p className="text-xs mt-4 font-bold text-red-600">ZA STAN SE NEPLATÍ A JINÉ UBYTOVÁNÍ NEPOSKYTUJEME !!!</p>
            </div>
          </div>

          {/* Vyzvednutí lodí */}
          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow">
            <div className="text-center mb-4">
              <Anchor className="w-12 h-12 mx-auto text-blue-600 mb-2" />
              <h3 className="text-xl font-bold text-gray-800">Vyzvednutí lodí</h3>
            </div>
            <div className="text-center text-gray-700">
              <p className="font-semibold">Lodě IN-LIFE</p>
            </div>
          </div>

          {/* Dřevo */}
          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow">
            <div className="text-center mb-4">
              <svg className="w-12 h-12 mx-auto text-blue-600 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
              </svg>
              <h3 className="text-xl font-bold text-gray-800">Dřevo</h3>
            </div>
            <div className="text-center text-gray-700">
              <p className="text-sm mb-2">Dřevo na oheň pro bezvadnou noc</p>
              <p className="font-bold text-lg">Cena 130,- Kč</p>
            </div>
          </div>

          {/* Sprcha */}
          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow">
            <div className="text-center mb-4">
              <svg className="w-12 h-12 mx-auto text-blue-600 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <h3 className="text-xl font-bold text-gray-800">Sprcha</h3>
            </div>
            <div className="text-center text-gray-700">
              <p className="text-sm">Žeton TV</p>
              <p className="font-bold">5min. 40,- Kč</p>
              <p className="text-xs mt-2">-Možnost zakoupení u obsluhy-</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sluzby;
